export default __webpack_public_path__ + "static/media/ban-for-unsubscribe.74294a45.svg";